// extracted by mini-css-extract-plugin
export var linkText = "_na-0";